/* eslint-disable */
import React, { useRef, useState } from 'react';
// material
import { alpha } from '@mui/material/styles';
import { Avatar, Box, Divider, IconButton, Typography } from '@mui/material';
// components
import MenuPopover from "@/components/menu-popover/MenuPopover";
import SignOutButton from "@/components/navSection/SignOut";
import StepOne from "@/features/user/register/stepOne";
import StepTwo from "@/features/user/register/stepTwo";
import StepThree from "@/features/user/register/stepThree";
import StepFour from "@/features/user/register/stepFour";
import ContactInfo from "@/features/user/contactInfo";
import UserLogoComponent from "@/features/user/logo";
import UserCFDIBGComponent from "@/features/user/cfdiBackground";
import SeriesFolioComponent from "@/features/user/seriesFolios";
import { Icon } from "@iconify/react";
import avatarIcon from '@iconify/icons-eva/settings-2-outline';
import { useSelector } from "react-redux";
import { selectCurrentUser, selectIsRegisterCompleted } from "@/store/slices/authSlice";
//import { stringAvatar } from "@/utils";
import { getRegisterStatus } from "@/helpers/local-storage";
import ExtraFields from "@/features/user/extraFields";

export default function AccountPopover(): any {
    const anchorRef = useRef(null);
    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    // current user logged
    const user: any = useSelector(selectCurrentUser);

    // obtener user scopes
    const role: string = user?.roles[0];

    // obtener si ya completó registro
    const register_complete: boolean = getRegisterStatus();
    const register_complete_stored: boolean = useSelector(selectIsRegisterCompleted);

    const from: string = "Account popover";

    return (
        <>
            <IconButton
                ref={anchorRef}
                onClick={handleOpen}
                sx={{
                    padding: 0,
                    width: 44,
                    height: 44,
                    ...(open && {
                        '&:before': {
                            zIndex: 1,
                            content: "''",
                            width: '100%',
                            height: '100%',
                            borderRadius: '50%',
                            position: 'absolute',
                            bgcolor: (theme) => alpha(theme.palette.grey[500], 0.72)
                        }
                    })
                }}
            >
                <Avatar
                    // {...stringAvatar(user?.name || 'GUEST NAME')}
                    sx={{ bgcolor: '#116FFF' }}
                >
                    <Icon icon={avatarIcon} width={20} />

                </Avatar>
            </IconButton>

            <MenuPopover
                open={open}
                onClose={handleClose}
                anchorEl={anchorRef.current}
                sx={{ width: 220 }}
            >
                <Box sx={{ my: 1.5, px: 2.5 }}>
                    <Typography variant="subtitle1" noWrap>
                        {user?.name || 'GUEST NAME'}
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
                        {user?.email || 'guest@email.com'}
                    </Typography>
                </Box>

                <Divider sx={{ my: 1 }} />

                {
                    ((role && role !== 'SuperAdminRole') && (register_complete || register_complete_stored)) &&
                    (
                        <>
                            <StepTwo isModal={true} closePopover={handleClose} from={from}/>
                            <StepOne isModal={true} closePopover={handleClose} from={from}/>
                            <StepFour isModal={true} closePopover={handleClose} from={from}/>
                            <ContactInfo isModal={true} closePopover={handleClose} from={from}/>

                            <Divider sx={{ my: 1 }} />

                            <UserLogoComponent isModal={true} closePopover={handleClose} from={from}/>
                            <UserCFDIBGComponent isModal={true} closePopover={handleClose} from={from}/>

                            <Divider sx={{ my: 1 }} />

                            <StepThree isModal={true} closePopover={handleClose} from={from}/>
                            <SeriesFolioComponent isModal={true} closePopover={handleClose} from={from}/>
                            <ExtraFields isModal={true} closePopover={handleClose} from={from}/>

                            <Divider sx={{ my: 1 }} />
                        </>
                    )
                }

                <SignOutButton />
            </MenuPopover>
        </>
    );
}
